import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'thank',
  templateUrl: 'thank.component.html',
  styleUrls: ['../../+register/thank/thank.component.css']
})

export class Thank2Component implements OnInit {

  constructor(
    private router: Router,
  ) {}

  ngOnInit() { 
    window.scroll(0, 0);
  }

  home() {
    this.router.navigate(['/']);
  }

  dash() {
    this.router.navigate(['/dashboard']);
  }

}